import { gql } from '@apollo/client';

export const ADD_UPDATE_REPORT = gql`
  mutation addOrUpdateReport($input: ReportItemInput) {
    addOrUpdateReport(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_REPORT_PARAMETER = gql`
  mutation addOrUpdateReportParameter($input: AddOrUpdateReportParameterInput) {
    addOrUpdateReportParameter(input: $input) {
      commandId
    }
  }
`;

export const REMOVE_REPORT_PARAMETER_INPUT = gql`
  mutation removeReportParameter($input: RemoveReportParameterInput) {
    removeReportParameter(input: $input) {
      commandId
    }
  }
`;

export const ADD_UPDATE_REPORT_FILTER = gql`
  mutation addOrUpdateReportFilter($input: AddOrUpdateReportFilterInput) {
    addOrUpdateReportFilter(input: $input) {
      commandId
    }
  }
`;

export const REMOVE_REPORT_FILTER_INPUT = gql`
  mutation removeReportFilter($input: RemoveReportFilterInput) {
    removeReportFilter(input: $input) {
      commandId
    }
  }
`;

export const SAVE_REPORTS_X_USER_GROUPS = gql`
  mutation saveReportXUserGroups($input: SaveReportXUserGroupsInput) {
    saveReportXUserGroups(input: $input) {
      commandId
    }
  }
`;
